module.exports = __webpack_public_path__ + "static/media/profile.266be6b0.svg";